import { render, staticRenderFns } from "./devicesold.vue?vue&type=template&id=ed006a84&scoped=true&"
import script from "./devicesold.vue?vue&type=script&lang=js&"
export * from "./devicesold.vue?vue&type=script&lang=js&"
import style0 from "./devicesold.vue?vue&type=style&index=0&id=ed006a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed006a84",
  null
  
)

export default component.exports